import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges,
} from "@angular/core";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  PlanningProjectDraftSelectListComponent
} from "../planning-project-draft-select-list/planning-project-draft-select-list.component";
import {ViewSettingsModel} from "../../../../commons/models/view-settings.model";

require('./planning-project-draft-select.scss');
@Component({
  standalone: false,
  selector: 'app-planning-project-draft-select',
  templateUrl: './planning-project-draft-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningProjectDraftSelectComponent implements OnInit, OnChanges {

  @Input() projectId: string;
  @Input() selectedDraft: any;
  @Input() drafts: any;
  @Input() defaultDraftId?: string;
  @Input() isDisabled: any;
  @Output() onSelectDraft = new EventEmitter<string>();

  public selectedDraftName: string = '';

  constructor(@Inject(PanelService) private panelService: PanelService) {
  }

  ngOnInit() {
    this.setSelectedDraftName();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDraft && !changes.selectedDraft.isFirstChange()) {
      this.setSelectedDraftName();
    }
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(PlanningProjectDraftSelectListComponent, event, {
      projectId: this.projectId,
      selectedDraftId: this.selectedDraft?.id,
      drafts: this.drafts.sort((a, b) => b.createdAt - a.createdAt),
      defaultDraftId: this.defaultDraftId
    }, {
      width: 150,
      height: 300
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        if (data?.selectedDraftId) {
          this.onSelectDraft.emit(data.selectedDraftId);
        }
      })
    }

  }

  private setSelectedDraftName() {
    this.selectedDraftName = !!this.selectedDraft ? this.selectedDraft.name : '';
  }

}
